import { Component, EventEmitter, Input, Output } from '@angular/core';


@Component({
    moduleId: module.id.toString(),
    selector: 'yeti-tab-item',
    template: require('./tab-item.html'),
    styles: [require('./tab-item.component.scss')]
})

export class TabItemComponent {
    protected active: boolean = false;

    @Input() isActivated: boolean = false;
    @Input() tabHeader: string = null;
    @Input() isInvalid: boolean = true;
    @Output() onActivated = new EventEmitter<any>();
    @Output() onDeactivated = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit() {

    }

    activate() {
        if (!this.active) {
            this.active = true;
            this.onActivated.emit();
        }
    }

    deactivate() {
        if (this.active) {
            this.active = false;
            this.onDeactivated.emit();
        }
    }

    resetActivation(state: boolean) {
        this.active = state;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/tab-menu/tab-item.component.ts